module.exports = __webpack_public_path__ + "static/media/disabledInProgressIcon.e03d142f.svg";